/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the software.

*/

import React from "react";
import { createRoot} from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "App";

// Vision UI Dashboard React Context Provider
import { VisionUIControllerProvider } from "context";
import { AuthzProvider } from "context/AuthzContext";

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const Router = window.location.hash.startsWith("#/cs-review/") ? HashRouter : BrowserRouter;

// Expose a quick demo-mode flag when ?demo=true is present so local development
// can preview the dashboard without Firebase auth. Not for production use.
try {
  const params = new URLSearchParams(window.location.search);
  window.__LEDGERHUB_DEMO = params.get("demo") === "true";
} catch (e) {
  window.__LEDGERHUB_DEMO = false;
}

root.render(<Router>
  <VisionUIControllerProvider>
    <AuthzProvider>
      <App />
    </AuthzProvider>
  </VisionUIControllerProvider>
</Router>)

